import { apiClient } from '@/utils/api-client';
import { toNumber } from '@/utils/number-operations';
import type {
  FundCostCategory,
  FundCostPage,
  FundCost,
  FundCostCreate,
  FundCostCreateResponse,
  FundCostUpdate,
  FundCostRecognitionEntry,
  FundCostsSummary,
} from '@/types/fund-costs';

export const fundCostService = {
  async list(
    fundId: string,
    params?: {
      cost_category?: FundCostCategory;
      page?: number;
      page_size?: number;
    }
  ): Promise<FundCostPage> {
    return await apiClient.get(`/funds/${fundId}/costs`, { params });
  },

  async summary(fundId: string): Promise<FundCostsSummary> {
    return await apiClient.get(`/funds/${fundId}/costs/summary`);
  },

  async get(fundId: string, costId: string): Promise<FundCost> {
    return await apiClient.get(`/funds/${fundId}/costs/${costId}`);
  },

  async create(
    fundId: string,
    data: FundCostCreate
  ): Promise<FundCostCreateResponse> {
    return await apiClient.post(`/funds/${fundId}/costs`, data);
  },

  async update(
    fundId: string,
    costId: string,
    data: FundCostUpdate
  ): Promise<FundCostCreateResponse> {
    return await apiClient.patch(`/funds/${fundId}/costs/${costId}`, data);
  },

  async delete(fundId: string, costId: string): Promise<void> {
    await apiClient.delete(`/funds/${fundId}/costs/${costId}`);
  },

  async recognition(
    fundId: string,
    costId: string
  ): Promise<FundCostRecognitionEntry[]> {
    const entries = await apiClient.get<FundCostRecognitionEntry[]>(
      `/funds/${fundId}/costs/${costId}/recognition`
    );
    return entries.map((entry) => ({
      ...entry,
      amount: toNumber(entry.amount),
    }));
  },
};
